<template>
  <BaseTable
    :isLoading="isLoading"
    :tableData="data"
    :totalItemsCount="totalItemsCount"
    :perPage="perPage"
    :currentPage="currentPage"
    :showSearch="false"
    :showCreateButton="rolPermissions.isAllowedCreate"
    createLabel="New Company"
    @create="$emit('openModal')"
    @paginate="paginate"
  >
    <template #columns>
      <Column field="name" header="Name" :styles="{ 'min-width': '10rem' }">
        <template #body="{ data }">
          <p>{{ data.name }}</p>
        </template>
      </Column>
      <Column
        v-if="loggedUser && loggedUser.role !== 'global_admin'"
        field="description"
        header="Description"
        :styles="{ 'min-width': '10rem' }"
      >
        <template #body="{ data }">
          {{ data.description }}
        </template>
      </Column>
    </template>

    <template #actions-column>
      <Column v-if="!rolPermissions.noActions" header="Actions">
        <template #body="{ data }">
          <div class="data-table__actions">
            <span v-if="rolPermissions.isAllowedEdit" @click="$emit('openModal', data)">
              <i class="pi pi-pencil"></i>
            </span>
            <span v-if="rolPermissions.isAllowedDelete" @click="deleteRow(data)">
              <i class="pi pi-trash"></i>
            </span>
          </div>
        </template>
      </Column>
    </template>
  </BaseTable>
</template>

<script>
import { mapGetters } from "vuex";
import { successMessage, deleteMessage } from "@/utils/alertMessages";
import { rolPermissions } from "@/mixins/itemsTable/infoUser";
import BaseTable from "./BaseTable.vue";

export default {
  name: "CompanyTable",
  components: { BaseTable },
  props: ["firstPage"],
  emits: ["openModal"],
  data() {
    return {
      isLoading: false,
      data: [],
      loggedUser: null,
      rolPermissions: {},
      confirmationDeleteMessage: "I'm sure I want to delete this",
      totalItemsCount: 0,
      currentPage: 1,
      perPage: 15,
    };
  },
  computed: {
    ...mapGetters("user", ["showCurrentCompanyDepartment"]),
  },
  watch: {
    firstPage() {
      this.currentPage = 1;
    },
  },
  async created() {
    this.loggedUser = JSON.parse(localStorage.getItem("user-info"));
    this.getUserPermissions();
    await this.getCompanies();
  },
  methods: {
    getUserPermissions() {
      this.rolPermissions = rolPermissions(this.loggedUser, "Company");
    },
    async getCompanies() {
      this.isLoading = true;
      const params = { limit: 15, skip: (this.currentPage - 1) * 15 };
      const info = await this.$store.dispatch("company/getAllCompanies", params);
      this.data = info.data;
      this.totalItemsCount = info.count;
      this.isLoading = false;
    },
    async paginate(page) {
      this.currentPage = page;
      await this.getCompanies();
      window.scrollTo(0, 0);
    },
    async deleteRow(companyData) {
      const msg = "Are you sure you want to remove Company from the system?";
      const warningResponse = await deleteMessage(msg, "You won't be able to revert this!");
      if (warningResponse.isConfirmed) {
        const params = {
          company_id: companyData.id,
          confirmation_message: this.confirmationDeleteMessage,
        };
        const response = await this.$store.dispatch("company/deleteCompany", params);
        if (response.status === 200 || response.status === 204) {
          successMessage("The company has been deleted.");
          if (this.data.length === 1 && this.currentPage > 1) this.currentPage -= 1;
          await this.getCompanies();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@include table-action-icons;
</style>
